import { useCallback } from 'react';
import { Journals } from '../../types/Journals.types';
import { SearchResult } from '../../types/Search.types';
import { useApi } from './useApi';

export const useSearch = () => {
  const { makeApiRequest } = useApi();

  const searchJournals = useCallback(
    async (
      searchQuery: string,
      licenses: string[],
      publishingModels: string[],
      payments: string[],
      imprints: string[],
      statuses: string[]
    ) => {
      if (searchQuery === '') {
        return {
          data: { data: [] as Journals[] } as SearchResult,
          licenses,
          publishingModels,
          payments,
          imprints,
          statuses,
        };
      }

      const params = new URLSearchParams();
      params.set('term', searchQuery);
      licenses.forEach((l) => params.append('licenses[]', l));
      publishingModels.forEach((m) => params.append('publishing_model[]', m));
      payments.forEach((p) => params.append('payment[]', p));
      imprints.forEach((i) => params.append('imprint[]', i));
      statuses.forEach((s) => params.append('status[]', s));

      const response = await makeApiRequest<SearchResult>(
        `/search?${params.toString()}`,
        'GET'
      );
      const responseLicenses: Set<string> = new Set(
        response?.filters?.licenses
      );
      const responsePublishingModels: Set<string> = new Set(
        response?.filters?.publishing_models
      );
      const responsePayments: Set<string> = new Set(
        response?.filters?.payments
      );
      const responseImprints: Set<string> = new Set(
        response?.filters?.imprints
      );
      const responseStatuses: Set<string> = new Set(
        response?.filters?.statuses
      );

      const sortSet = (set: Set<string>) => {
        return Array.from(set).sort((a, b) => {
          return a.localeCompare(b);
        });
      };

      return {
        licenses: sortSet(responseLicenses),
        publishingModels: sortSet(responsePublishingModels),
        payments: sortSet(responsePayments),
        imprints: sortSet(responseImprints),
        statuses: sortSet(responseStatuses),
        data: response,
      };
    },
    [makeApiRequest]
  );

  return {
    searchJournals,
  };
};
